import {
  faSolidPeopleSlash,
} from '@awesome.me/kit-ebe9b8978a/icons/kit/custom';
import type { CustomIconDefinition } from '@/common/custom-icons.ts';

export const faCustomIcons: CustomIconDefinition[] = [
  { library: 'fa-custom', name: 'solid-people-slash', icon: faSolidPeopleSlash },
];
